(function () {
  'use strict';

  /* Alle kurv-kald går gennem butikkens sprogrod (/da-dk/), ellers svarer Shopify med
     engelske produkttitler («Kickstand» i stedet for «Støtteben»). 12-10-2026. */
  var CART_ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* ============================================================
     SELECTORS
     ============================================================ */
  var drawer       = document.getElementById('cart-drawer');
  var overlay      = document.getElementById('cart-drawer-overlay');
  var closeBtn     = document.getElementById('cart-drawer-close');
  var itemsEl      = document.getElementById('cart-drawer-items');
  var subtotalEl   = document.getElementById('cart-subtotal');
  var shippingBar     = document.getElementById('cart-shipping-bar');
  var shippingFill    = document.getElementById('cart-shipping-fill');
  var shippingText    = document.getElementById('cart-shipping-text');
  var shippingCurrent = document.getElementById('cart-shipping-current');
  var shippingLabel   = document.getElementById('cart-shipping-label');
  function getCartCountEls() {
    return document.querySelectorAll('.site-header__cart-count, .bike-cfg-header__cart-count, [data-cart-count]');
  }

  /* ============================================================
     OPEN / CLOSE
     ============================================================ */
  window.openCartDrawer = function () {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.setProperty('--scrollbar-width', (window.innerWidth - document.documentElement.clientWidth) + 'px');
    document.documentElement.setAttribute('scroll-lock', '');
  };

  window.closeCartDrawer = function () {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.removeAttribute('scroll-lock');
    document.documentElement.style.removeProperty('--scrollbar-width');
  };

  if (overlay)  overlay.addEventListener('click', window.closeCartDrawer);
  if (closeBtn) closeBtn.addEventListener('click', window.closeCartDrawer);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') window.closeCartDrawer();
  });

  /* ============================================================
     HELPERS
     ============================================================ */
  /* Active PRESENTMENT currency for the buyer's market. Seeded from Liquid
     (data-currency="{{ cart.currency.iso_code }}" on #cart-drawer) and kept in
     sync with every /cart.js fetch (cart.currency) — the authoritative source for
     the amounts we format. We deliberately do NOT use Shopify.currency.active: it
     returns the SHOP's base currency (DKK), so EUR carts rendered the right number
     with a "kr" label. */
  var activeCurrency =
    (drawer && drawer.dataset && drawer.dataset.currency) ||
    (window.Shopify && Shopify.currency && Shopify.currency.active) ||
    'DKK';

  function moneyFormat(cents) {
    var cur = activeCurrency || 'DKK';
    /* Ører kun når der er ører: en linje med 50 % på 1.275 kr koster 637,50 kr i kassen,
       og kurven må ikke runde den til 638 kr (26-10-2026, Website #33). */
    var c = Math.round(cents);
    var dec = (c % 100 !== 0) ? 2 : 0;
    var whole = (c / 100).toLocaleString('da-DK', { minimumFractionDigits: dec, maximumFractionDigits: dec });
    if (cur === 'EUR') return '€' + whole;
    if (cur === 'DKK') return whole + ' kr';
    try { return new Intl.NumberFormat('da-DK', { style: 'currency', currency: cur, maximumFractionDigits: 0 }).format(cents / 100); }
    catch (e) { return whole + ' ' + cur; }
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body),
      credentials: 'same-origin'
    }).then(function (r) {
      if (!r.ok) {
        return r.json().then(
          function (err) {
            throw new Error((err && (err.description || err.message)) || ('Cart request failed: ' + r.status));
          },
          function () {
            throw new Error('Cart request failed: ' + r.status);
          }
        );
      }
      return r.json();
    });
  }

  function getCart() {
    return fetch(CART_ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // /cart.js reports the presentment currency for the amounts it returns —
        // keep the formatter in sync so the symbol/code always matches the number.
        if (cart && cart.currency) activeCurrency = cart.currency;
        return cart;
      });
  }

  /* ============================================================
     RENDER
     ============================================================ */
  /* Localized build-card strings, passed from Liquid via data-* on #cart-drawer
     (the {% javascript %}/asset layer can't run Liquid). Fallbacks in English. */
  function buildLabels() {
    var d = (drawer && drawer.dataset) || {};
    return {
      title:  d.buildTitle  || 'Your build',
      addons: d.buildAddons || 'Add-ons',
      gift:   d.buildGift   || 'Gift',
      free:   d.buildFree   || 'Free',
      total:  d.buildTotal  || 'Build total',
      edit:   d.buildEdit   || 'Edit ebike {n}',
      del:    d.buildDelete || 'Delete bike'
    };
  }

  /* Spec chips for the bike hero: prefer options_with_values, fall back to
     splitting the variant title. 'Default Title' values are skipped. */
  function specChips(item) {
    var vals = [];
    if (Array.isArray(item.options_with_values)) {
      item.options_with_values.forEach(function (o) {
        if (o && o.value && o.value !== 'Default Title') vals.push(o.value);
      });
    } else if (item.variant_title && item.variant_title !== 'Default Title') {
      vals = item.variant_title.split(' / ');
    }
    /* En reservation har ingen varianter — dens opsætning ligger i en
       linjeegenskab. Uden dette står reservationen helt uden specs. */
    if (!vals.length && item.properties && item.properties._bike_build) {
      vals = String(item.properties._bike_build).split(' \u00b7 ');
    }
    return vals.map(function (v) {
      return '<span class="cart-build__chip">' + escHtml(v) + '</span>';
    }).join('');
  }

  /* Keep cart links inside the current market root (e.g. /da-dk) so a Danish
     shopper is never bounced back to the EUR store. item.url from /cart.js is
     root-relative ("/products/…", no market prefix), so we prepend the locale
     root exposed by Shopify.routes.root. */
  function localizedUrl(u) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    if (!root || root === '/') return u;
    return root.replace(/\/$/, '') + u;
  }

  function heroHtml(item, labels, index) {
    var img = item.image
      ? '<img src="' + escHtml(item.image) + '" alt="' + escHtml(item.product_title) + '" width="76" height="76" loading="lazy" class="cart-build__hero-img">'
      : '';
    /* Editing a build = delete + reconfigure, so there is no separate "Edit bike"
       link — only the Delete bike button below. (The old edit link also pointed
       at the root /products URL, which bounced Danish shoppers to the EUR store.) */
    var url = localizedUrl(item.url);
    return [
      '<div class="cart-build__hero" data-key="' + escHtml(item.key) + '">',
        '<a href="' + escHtml(url) + '" class="cart-build__hero-imglink">' + img + '</a>',
        '<div class="cart-build__hero-info">',
          '<div class="cart-build__hero-top">',
            '<a href="' + escHtml(url) + '" class="cart-build__hero-title">' + escHtml(item.product_title) + '</a>',
            '<span class="cart-build__hero-price font-mono">' + moneyFormat(item.final_line_price) + '</span>',
          '</div>',
          '<div class="cart-build__chips">' + specChips(item) + '</div>',
          '<div class="cart-build__hero-actions">',
            '<button type="button" class="cart-build__delete" data-build-delete>' + escHtml(labels.del) + '</button>',
          '</div>',
        '</div>',
      '</div>'
    ].join('');
  }

  function addonRowHtml(item, labels) {
    var key = escHtml(item.key);
    var thumb = item.image
      ? '<img src="' + escHtml(item.image) + '" alt="" width="40" height="40" loading="lazy" class="cart-build__row-img">'
      : '<span class="cart-build__row-dot" aria-hidden="true"></span>';
    var qty = item.quantity > 1 ? '<span class="cart-build__row-qty">\u00d7' + item.quantity + '</span>' : '';
    /* En automatisk rabat p\u00e5 linjen (fx Black Month p\u00e5 b\u00e6rerne, Website #33) st\u00e5r i /cart.js
       som final_line_price under original_line_price. Kurven viser begge, s\u00e5 kunden ser den
       samme besparelse som p\u00e5 kortet, men kun n\u00e5r kurven selv har den. */
    var was = item.original_line_price > item.final_line_price
      ? '<s class="cart-build__was">' + moneyFormat(item.original_line_price) + '</s> '
      : '';
    return [
      '<div class="cart-build__row" data-key="' + key + '">',
        thumb,
        '<span class="cart-build__row-title">' + escHtml(item.product_title) + '</span>',
        qty,
        /* Med i prisen (rabat 100 %, Website #62): «Inkluderet» i stedet for «0 kr». */
        '<span class="cart-build__row-price font-mono">' + was + ((item.final_line_price === 0 && item.original_line_price > 0 && labels && labels.free) ? escHtml(labels.free) : moneyFormat(item.final_line_price)) + '</span>',
        '<button type="button" class="cart-build__row-remove" data-build-remove data-key="' + key + '" aria-label="Remove">',
          '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>',
        '</button>',
      '</div>'
    ].join('');
  }

  function giftRowHtml(item, labels) {
    /* Gift lines are always free: the "Free gifts with City U" automatic discount
       zeroes them at checkout, but BxGy discounts don't surface in /cart.js line
       prices — so we show Free here to match what the buyer is actually charged. */
    /* Værdien står overstreget før «Inkluderet», som batteriets «1.095 kr Inkluderet».
       original_line_price er varens egen pris; rabatten ses ikke i /cart.js. */
    var was = item.original_line_price > 0
      ? '<s class="cart-build__was">' + moneyFormat(item.original_line_price) + '</s> '
      : '';
    var priceText = labels.free;
    return [
      '<div class="cart-build__row cart-build__row--gift" data-key="' + escHtml(item.key) + '">',
        '<span class="cart-build__gift-pill">' + escHtml(labels.gift) + '</span>',
        '<span class="cart-build__row-title">' + escHtml(item.product_title) + '</span>',
        '<span class="cart-build__row-price font-mono">' + was + escHtml(priceText) + '</span>',
      '</div>'
    ].join('');
  }

  /* The premium build card: bike hero on top, add-ons by price (high \u2192 low),
     gifts last, then a build total. */
  function buildCardHtml(items, index) {
    var labels = buildLabels();
    var bike = null, addons = [], gifts = [], totalCents = 0, buildId = '';

    items.forEach(function (it) {
      if (it.properties && it.properties._build_id) buildId = it.properties._build_id;
      var role = it.properties._build_role;
      /* 'reservation' skal opføre sig som cyklen: den ER ordren, bare betalt
         delvist. Uden denne linje faldt den i else-grenen og blev vist under
         "Tilvalg" uden specs. */
      if (role === 'bike' || role === 'reservation') { bike = it; totalCents += it.final_line_price; }
      else if (role === 'gift') { gifts.push(it); } /* free at checkout — not in the total */
      else { addons.push(it); totalCents += it.final_line_price; }
    });
    addons.sort(function (a, b) { return b.final_line_price - a.final_line_price; });

    var idAttr = buildId ? ' data-build-id="' + escHtml(buildId) + '"' : '';
    var parts = ['<div class="cart-build"' + idAttr + '>'];
    parts.push('<p class="cart-build__eyebrow">' + escHtml(labels.title) + '</p>');
    if (bike) parts.push(heroHtml(bike, labels, index));

    /* Reservationen er ÉN kurvlinje, så der findes ingen tilvalgs- eller
       gavelinjer at gruppere. Rækkerne bygges i stedet af de egenskaber
       konfiguratoren stemplede på linjen, så kortet ser ud som cyklens. */
    var isReservation = bike && bike.properties && bike.properties._build_role === 'reservation';
    if (isReservation) {
      var rAddons = String(bike.properties._bike_addons || '').split(';').filter(Boolean);
      var rGifts  = String(bike.properties._bike_gifts  || '').split(';').filter(Boolean);
      if (rAddons.length || rGifts.length) {
        parts.push('<div class="cart-build__list">');
        if (rAddons.length) {
          parts.push('<p class="cart-build__section">' + escHtml(labels.addons) + '</p>');
          rAddons.forEach(function (raw) {
            var bits = raw.split('|');
            var name = bits[0] || '';
            var cents = parseInt(bits[1], 10);
            /* Tredje felt (encodet billed-URL) kom til 31-08-2026 — ældre kurve
               har det ikke, så prikken består som fallback. */
            var imUrl = '';
            try { imUrl = bits[2] ? decodeURIComponent(bits[2]) : ''; } catch (e) {}
            var thumb = imUrl
              ? '<img src="' + escHtml(imUrl.replace('width=800', 'width=120')) + '" alt="" width="40" height="40" loading="lazy" class="cart-build__row-img">'
              : '<span class="cart-build__row-dot" aria-hidden="true"></span>';
            parts.push(
              '<div class="cart-build__row">' +
                thumb +
                '<span class="cart-build__row-title">' + escHtml(name) + '</span>' +
                '<span class="cart-build__row-price font-mono">' +
                  (isNaN(cents) ? '' : moneyFormat(cents)) +
                '</span>' +
              '</div>'
            );
          });
        }
        rGifts.forEach(function (name) {
          parts.push(
            '<div class="cart-build__row cart-build__row--gift">' +
              '<span class="cart-build__gift-tag">' + escHtml(labels.gift) + '</span>' +
              '<span class="cart-build__row-title">' + escHtml(name) + '</span>' +
              '<span class="cart-build__row-price font-mono">' + escHtml(labels.free) + '</span>' +
            '</div>'
          );
        });
        parts.push('</div>');
      }
    }

    if (addons.length || gifts.length) {
      parts.push('<div class="cart-build__list">');
      if (addons.length) {
        parts.push('<p class="cart-build__section">' + escHtml(labels.addons) + '</p>');
        addons.forEach(function (it) { parts.push(addonRowHtml(it, labels)); });
      }
      gifts.forEach(function (it) { parts.push(giftRowHtml(it, labels)); });
      parts.push('</div>');
    }

    parts.push(
      '<div class="cart-build__total"><span>' + escHtml(labels.total) + '</span>' +
      '<span class="cart-build__total-amount font-mono">' + moneyFormat(totalCents) + '</span></div>'
    );
    parts.push('</div>');
    return parts.join('');
  }

  /* Exposed so the configurator's pre-order modal can render the exact same
     premium build card from the just-added cart lines. */
  window.bycycleRenderBuildCard = buildCardHtml;

  /* Generic flat row \u2014 unchanged behavior for non-build items. */
  function flatItemHtml(item) {
    var variantLine = item.variant_title && item.variant_title !== 'Default Title'
      ? '<p class="cart-item__variant">' + escHtml(item.variant_title) + '</p>'
      : '';

    var imgHtml = item.image
      ? '<img src="' + item.image + '" alt="' + escHtml(item.title) + '" width="60" height="60" loading="lazy" class="cart-item__image">'
      : '';

    var key = escHtml(item.key);
    return [
      '<div class="cart-item" data-key="' + key + '">',
        '<a href="' + escHtml(item.url) + '" class="cart-item__image-link">' + imgHtml + '</a>',
        '<div class="cart-item__details">',
          '<div class="cart-item__title-row">',
            '<a href="' + escHtml(item.url) + '" class="cart-item__title">' + escHtml(item.product_title) + '</a>',
            '<span class="cart-item__price font-mono">' + moneyFormat(item.final_line_price) + '</span>',
          '</div>',
          variantLine,
          '<div class="cart-item__qty" data-key="' + key + '">',
            '<button type="button" class="cart-item__qty-btn" data-action="decrease" aria-label="Decrease quantity">\u2212</button>',
            '<span class="cart-item__qty-value">' + item.quantity + '</span>',
            '<button type="button" class="cart-item__qty-btn" data-action="increase" aria-label="Increase quantity">+</button>',
          '</div>',
        '</div>',
      '</div>'
    ].join('');
  }

  /* Group build lines by their _build_id so each pre-ordered bike renders as
     its own card. Lines without an id (old carts) fall into one '_legacy'
     group and render as a single card, preserving prior behavior. */
  function groupBuilds(items) {
    var order = [], map = {};
    items.forEach(function (it) {
      var id = (it.properties && it.properties._build_id) || '_legacy';
      if (!map[id]) { map[id] = []; order.push(id); }
      map[id].push(it);
    });
    return order.map(function (id) { return map[id]; });
  }

  /* Render every build as its own card (grouped per bike). Shared with the
     pre-order modal via window.bycycleRenderBuilds so the two never drift. */
  function renderBuildsHtml(items) {
    var build = (items || []).filter(function (it) { return it.properties && it.properties._build_role; });
    return groupBuilds(build).map(function (group, i) { return buildCardHtml(group, i + 1); }).join('');
  }
  window.bycycleRenderBuilds = renderBuildsHtml;

  function renderItems(cart) {
    if (!itemsEl) return;

    if (!cart.item_count) {
      /* Tom kurv fra skabelonen i snippets/cart-drawer.liquid (empty_cart_style),
         så den er oversat og samme udgave som ved sideindlæsning. */
      var emptyTpl = document.getElementById('cart-empty-tpl');
      itemsEl.innerHTML = emptyTpl ? emptyTpl.innerHTML : '<div class="cart-drawer__empty"><p>Your cart is empty.</p></div>';
      return;
    }

    /* A configured bike build = any line tagged with _build_role at add-time. */
    var build = [];
    var others = [];
    cart.items.forEach(function (item) {
      if (item.properties && item.properties._build_role) build.push(item);
      else others.push(item);
    });

    var html = '';
    if (build.length) html += renderBuildsHtml(build);
    if (others.length) html += others.map(flatItemHtml).join('');

    itemsEl.innerHTML = html;
  }

  function updateShippingBar(cart) {
    if (!shippingBar) return;
    var threshold = parseInt(shippingBar.getAttribute('data-threshold'), 10) || 200000;
    var total     = cart.total_price;
    var pct       = Math.min(100, Math.round((total / threshold) * 100));
    var reached   = total >= threshold;

    if (shippingFill) shippingFill.style.width = pct + '%';
    if (shippingCurrent) shippingCurrent.textContent = moneyFormat(total);

    shippingBar.classList.toggle('is-reached', reached);
    shippingBar.classList.toggle('is-empty', cart.item_count === 0);

    if (shippingLabel) {
      shippingLabel.textContent = reached ? 'Unlocked' : 'Free shipping at';
    }
    if (shippingText) {
      if (reached) {
        shippingText.textContent = 'Free shipping is on us';
      } else {
        shippingText.textContent = 'Add ' + moneyFormat(threshold - total) + ' more for free shipping';
      }
    }

    shippingBar.setAttribute('data-total', total);
  }

  function updateCartCount(count) {
    getCartCountEls().forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  }

  function escHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* ============================================================
     REFRESH
     ============================================================ */
  window.refreshCartDrawer = function () {
    return getCart().then(function (cart) {
      renderItems(cart);
      updateShippingBar(cart);
      updateCartCount(cart.item_count);
      if (subtotalEl) subtotalEl.textContent = moneyFormat(cart.total_price);
      /* "Add another ebike" → the bike product page (fresh configurator), shown only when a build is in the cart. */
      var addAnother = document.getElementById('cart-add-another');
      if (addAnother) {
        var bikeLine = (cart.items || []).filter(function (it) { return it.properties && it.properties._build_role === 'bike'; })[0];
        if (bikeLine && bikeLine.url) { addAnother.setAttribute('href', bikeLine.url.split('?')[0]); addAnother.hidden = false; }
        else { addAnother.hidden = true; }
      }
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart, item_count: cart.item_count } }));
      return cart;
    });
  };

  /* ============================================================
     QUANTITY STEPPER & REMOVE (delegated)
     ============================================================ */
  function currentHeaderCount() {
    var first = getCartCountEls()[0];
    return first ? (parseInt(first.textContent, 10) || 0) : 0;
  }

  /* Per-line-key in-flight guard. Rapid clicks on the same line are
     ignored while a request is pending — prevents racing requests
     that could land out-of-order. */
  var pendingKeys = Object.create(null);

  if (itemsEl) {
    itemsEl.addEventListener('click', function (e) {
      var qtyBtn = e.target.closest('.cart-item__qty-btn');
      if (!qtyBtn) return;

      // Prevent any ancestor form (e.g. configurator's /cart/add) from
      // being submitted by this button click.
      e.preventDefault();
      e.stopPropagation();

      var qtyEl   = qtyBtn.closest('.cart-item__qty');
      var key     = qtyEl && qtyEl.getAttribute('data-key');
      if (!key || pendingKeys[key]) return;

      var valueEl = qtyEl && qtyEl.querySelector('.cart-item__qty-value');
      var current = valueEl ? parseInt(valueEl.textContent, 10) : 1;
      var action  = qtyBtn.getAttribute('data-action');
      var newQty  = action === 'increase' ? current + 1 : Math.max(0, current - 1);
      var delta   = newQty - current;

      if (valueEl) valueEl.textContent = newQty;
      updateCartCount(Math.max(0, currentHeaderCount() + delta));

      pendingKeys[key] = true;
      qtyBtn.disabled = true;
      post(CART_ROOT + 'cart/change.js', { id: key, quantity: newQty })
        .then(function () { return window.refreshCartDrawer(); })
        .catch(function (err) {
          console.error('Cart change failed:', err);
          return window.refreshCartDrawer();
        })
        .finally(function () {
          delete pendingKeys[key];
          qtyBtn.disabled = false;
        });
    });

    /* Build-card add-on remove (× button) — sets the line quantity to 0.
       Document-level so it works in the drawer AND the pre-order modal. */
    document.addEventListener('click', function (e) {
      var removeBtn = e.target.closest('[data-build-remove]');
      if (!removeBtn) return;

      e.preventDefault();
      e.stopPropagation();

      var key = removeBtn.getAttribute('data-key');
      if (!key || pendingKeys[key]) return;

      pendingKeys[key] = true;
      removeBtn.disabled = true;
      post(CART_ROOT + 'cart/change.js', { id: key, quantity: 0 })
        .then(function () { return window.refreshCartDrawer(); })
        .catch(function (err) {
          console.error('Cart remove failed:', err);
          return window.refreshCartDrawer();
        })
        .finally(function () {
          delete pendingKeys[key];
        });
    });

    /* The "Edit build" action was removed — editing a build is now just
       delete-and-reconfigure (the Delete bike button below). That also dropped
       a link pointing at the root /products URL, which bounced Danish shoppers
       to the EUR store. */

    /* Build-card "Delete bike" — instantly remove ONLY this card's own lines
       (bike + its add-ons + gifts), no confirm, no navigation. Scoped to a
       <button> so it never matches the .cart-drawer container's label attr.
       Document-level so it works in the drawer AND the modal. */
    document.addEventListener('click', function (e) {
      var delBtn = e.target.closest('button[data-build-delete]');
      if (!delBtn) return;
      e.preventDefault();
      var card = delBtn.closest('.cart-build');
      if (!card) return;
      var updates = {};
      card.querySelectorAll('[data-key]').forEach(function (el) {
        var k = el.getAttribute('data-key');
        if (k) updates[k] = 0;
      });
      if (!Object.keys(updates).length) return;
      delBtn.disabled = true;

      var commit = function () {
        post(CART_ROOT + 'cart/update.js', { updates: updates })
          .then(function () { return window.refreshCartDrawer(); })
          .catch(function (err) { console.error('Delete bike failed:', err); return window.refreshCartDrawer(); });
      };

      /* Cinematic exit: fade + shrink the card, then collapse its space so the
         remaining builds glide up, THEN commit the removal — the re-render then
         swaps in the updated list seamlessly. Honors reduced-motion. */
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce) { commit(); return; }

      card.style.height = card.offsetHeight + 'px';
      card.classList.add('cart-build--removing');
      void card.offsetHeight; /* reflow so the height transition has a start value */
      card.style.height = '0px';
      card.style.marginTop = '0px';
      card.style.marginBottom = '0px';

      var done = false;
      var finish = function () { if (done) return; done = true; commit(); };
      card.addEventListener('transitionend', function (ev) { if (ev.propertyName === 'height') finish(); });
      setTimeout(finish, 600); /* fallback if transitionend doesn't fire */
    });
  }

  /* ============================================================
     UPSELL ADD BUTTONS (delegated on drawer panel)
     ============================================================ */
  if (drawer) {
    drawer.addEventListener('click', function (e) {
      var addBtn = e.target.closest('.cart-upsell__add');
      if (!addBtn) return;
      var variantId = addBtn.getAttribute('data-variant-id');
      if (!variantId) return;

      addBtn.disabled = true;
      post(CART_ROOT + 'cart/add.js', { items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
        .then(function () {
          return window.refreshCartDrawer();
        })
        .finally(function () {
          addBtn.disabled = false;
        });
    });
  }

  /* ============================================================
     INTERCEPT ADD-TO-CART FORMS
     ============================================================ */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.getAttribute('action') !== '/cart/add') return;

    e.preventDefault();

    var data = new FormData(form);
    var body = {};
    data.forEach(function (val, key) { body[key] = val; });

    // Normalise to items array for the JSON endpoint
    var payload = body.items
      ? body
      : { items: [{ id: parseInt(body.id, 10), quantity: parseInt(body.quantity, 10) || 1 }] };

    post(CART_ROOT + 'cart/add.js', payload)
      .then(function () {
        return window.refreshCartDrawer();
      })
      .then(function () {
        window.openCartDrawer();
      });
  });

  /* ============================================================
     CART ICON CLICK (header button variant)
     ============================================================ */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-open-cart]');
    if (btn) {
      e.preventDefault();
      window.refreshCartDrawer().then(function () {
        window.openCartDrawer();
      });
    }
  });

  /* ============================================================
     SHARED CONFIRM DIALOG  →  window.bycycleConfirm() : Promise<boolean>
     Uses the once-rendered [data-confirm-dialog] element (defaults from
     locale); falls back to native confirm() if it's missing.
     ============================================================ */
  window.bycycleConfirm = function (opts) {
    opts = opts || {};
    return new Promise(function (resolve) {
      var dlg = document.querySelector('[data-confirm-dialog]');
      if (!dlg) { resolve(window.confirm(opts.body || 'Are you sure?')); return; }

      var titleEl = dlg.querySelector('[data-confirm-title]');
      var bodyEl  = dlg.querySelector('[data-confirm-body]');
      var okEl    = dlg.querySelector('[data-confirm-ok]');
      var cancels = dlg.querySelectorAll('[data-confirm-cancel]');
      if (opts.title && titleEl) titleEl.textContent = opts.title;
      if (opts.body && bodyEl) bodyEl.textContent = opts.body;
      if (opts.ok && okEl) okEl.textContent = opts.ok;

      var lastFocus = document.activeElement;

      function onKey(e) { if (e.key === 'Escape') cleanup(false); }
      function onOk() { cleanup(true); }
      function onCancel() { cleanup(false); }
      function cleanup(result) {
        dlg.classList.remove('is-open');
        dlg.setAttribute('aria-hidden', 'true');
        document.removeEventListener('keydown', onKey);
        if (okEl) okEl.removeEventListener('click', onOk);
        cancels.forEach(function (el) { el.removeEventListener('click', onCancel); });
        if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
        resolve(result);
      }

      if (okEl) okEl.addEventListener('click', onOk);
      cancels.forEach(function (el) { el.addEventListener('click', onCancel); });
      document.addEventListener('keydown', onKey);

      dlg.classList.add('is-open');
      dlg.setAttribute('aria-hidden', 'false');
      if (okEl) okEl.focus();
    });
  };

})();
